"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = _getPrototypeOf;

var _getPrototypeOf2 = _interopRequireDefault(require("../../core-js/object/get-prototype-of"));

var _setPrototypeOf = _interopRequireDefault(require("../../core-js/object/set-prototype-of"));

function _getPrototypeOf(o) {
  exports.default = _getPrototypeOf = _setPrototypeOf.default ? _getPrototypeOf2.default : function _getPrototypeOf(o) {
    return o.__proto__ || (0, _getPrototypeOf2.default)(o);
  };
  return _getPrototypeOf(o);
}